import { render, staticRenderFns } from "./LogisticsGoods.vue?vue&type=template&id=28f0f74a&scoped=true&"
import script from "./LogisticsGoods.vue?vue&type=script&lang=js&"
export * from "./LogisticsGoods.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsGoods.vue?vue&type=style&index=0&id=28f0f74a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0f74a",
  null
  
)

export default component.exports